import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
import { useEffect } from "preact/hooks";

import { NORESULTS_REC_ID } from "../config"

export default function SearchHeader({ mobile }) {
    const { query, response } = useAppState();
    const docCount = response.products?.total ?? 0

    useEffect(() => {
        if(!window.nostojs || docCount > 0) return;
        window.nostojs(api => {
            api
            .createRecommendationRequest({ includeTagging: true })
            .setElements([ NORESULTS_REC_ID ])
            .load({ skipPageViews: true, skipEvents: true })
        })
    }, [ docCount ]);

    return (
        <div className="px-6 lg:px-[30px] pt-4">
            <h1 className="h2 center">Search results</h1>
            {docCount > 0 ? (
                <h5 role="status" className="text-center lg:text-left mt-8 font-kangolMedium" data-nosto-element="totalResults">
                    {docCount === 1 ? "Result" : "Results"} for "{query.query}" ({docCount})
                </h5>
            ) : (
                <h5 role="status" className="text-center lg:text-left mt-8 font-kangolMedium">
                    No results found for "{docCount}". Check the spelling or use a different word or phrase.
                </h5>
            )}
            {docCount === 0 && (
                <div className="ns-noresults-rec-wrapper pt-10">
                    <div class="nosto_element" id={NORESULTS_REC_ID}></div>
                </div>
            )}
        </div>
    )
}
